import moment from 'moment';

// ISODate :: String
// @link: https://en.wikipedia.org/wiki/ISO_8601

// YYYY-MM-DDThh:mm:ss.sssZ :: "2017-08-16T19:49:50.940Z"
// YYYY-MM-DD               :: "2017-08-16"

// addYears :: ISODate, Number  -> ISODate
const addYears = (date, years) =>
  moment(date).add(years, 'years').toISOString();

export default addYears;
